import React from 'react';
import { twMerge } from '@/utils';
import arrowIcon from 'images/icons/arrow.svg';
import {
  ACTION_BAR_BTN_SHADOW,
  CIRCLE_ICON_CLASS,
} from '@/components/shared/NewLessonOverview/Cards/ActionBar/GoToButton';

interface DashboardCardProps {
  ariaLabel?: string;
  badge?: React.ReactNode;
  children?: React.ReactNode;
  href: string;
  imageUrl: string;
  numberLabel?: React.ReactNode;
  tag?: 'div' | 'li';
  title: string;
}

const DashboardCard = ({
  ariaLabel, badge, children, href, imageUrl, numberLabel, tag: Tag = 'div', title,
}: DashboardCardProps) => (
  <Tag
    className={twMerge(
      'tw-w-full tw-border-solid tw-border-[1px]',
      'tw-border-med-grey tw-rounded-lg tw-shadow-md tw-relative tw-bg-white',
    )}
  >
    {numberLabel}
    {badge}
    <a
      aria-label={ariaLabel}
      className={twMerge(
        'tw-block tw-h-full tw-w-full tw-rounded-lg',
        'hover:tw-no-underline',
      )}
      href={href}
    >
      <div className="tw-relative tw-p-1 tw-mb-1">
        {children}
        <div className="tw-w-full tw-relative tw-rounded-lg tw-overflow-hidden">
          <img
            alt=""
            className="tw-w-full tw-max-h-[180px] tw-object-cover tw-bg-center tw-aspect-video tw-block"
            src={imageUrl}
          />
          <div className="tw-absolute tw-inset-0 tw-bg-black tw-opacity-[20%] tw-pointer-events-none" />
        </div>
      </div>
      <div className="tw-flex tw-items-center tw-pl-[1.5rem] tw-pr-3 tw-py-2">
        <div className="tw-flex tw-flex-col tw-flex-1 tw-min-w-0">
          <p className={twMerge(
            'tw-text-[1.25rem] tw-font-bold tw-text-tci-purple',
            'hover:tw-underline hover:tw-decoration-tci-purple',
          )}
          >
            {title}
          </p>
        </div>
        <span
          aria-hidden="true"
          className={twMerge(CIRCLE_ICON_CLASS, 'tw-flex-shrink-0 tw-mr-0 tw-bg-tci-purple tw-text-white')}
          style={{ boxShadow: ACTION_BAR_BTN_SHADOW }}
        >
          <img aria-hidden alt="" src={arrowIcon} />
        </span>
      </div>
    </a>
  </Tag>
);

export default DashboardCard;
